import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    canceledLabel: (progressType: string) => string;
    partialUploaded: (uploaded: number, total: number) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Status label based on transfer type when canceled */
            canceledLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (progressType: string): string => __intl__.intl().formatMessage({ id: "CanceledJobStatus.canceledLabel?c=2vel3nciadhpq", defaultMessage: "{progressType, select, DOWNLOAD {Download canceled} RENDER {Export canceled} other {Upload canceled}}" }, { progressType: progressType }));
                },
                enumerable: true,
                configurable: true
            },
            /** Status showing partial upload progress before cancellation */
            partialUploaded: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (uploaded: number, total: number): string => __intl__.intl().formatMessage({ id: "CanceledJobStatus.partialUploaded?c=1lrfuwh5fnm5b", defaultMessage: "Uploaded {uploaded, number} out of {total, number}" }, { uploaded: uploaded, total: total }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
